import React, { useState, useRef, useEffect } from 'react';

import classNames from 'classnames';
import { Draggable } from 'react-beautiful-dnd';
import { DragHandleSmallIcon } from 'src/monet/icons';

import { DocumentCoreEditor } from './core-editor';
import { BlockSettings } from './components/block-settings';

import { DocumentBlock, DocumentJSON, DocumentBlockContent } from 'src/common/interfaces/document_block.interface';
import { useDocumentEditorContext } from 'src/store/document-editor';
import { useEditorOptions } from 'src/document-editor/use-editor-options.hook';

interface BlockEditorProps {
  key: string;
  draggableId: string;
  index: number;
  block: DocumentBlock;
  onUpdateBlock: (content: DocumentBlockContent) => void;
  onDeleteBlock: () => void;
}

/**
 *
 * @deprecated
 */
export const BlockEditor: React.FC<BlockEditorProps> = ({
  key,
  draggableId,
  index,
  block,
  onUpdateBlock,
  onDeleteBlock,
}) => {
  const editorRef = useRef(null);
  const [settingsFocused, setSettingsFocused] = useState(false);
  const [initialized, setInitialized] = useState(false);
  const shouldInitializeBlock = useDocumentEditorContext((state) => state.shouldInitializeBlock);
  const markBlockAsInitialized = useDocumentEditorContext((state) => state.markBlockAsInitialized);
  const getInitialBlockType = useDocumentEditorContext((state) => state.getInitialBlockType);

  const { insertBlockByType } = useEditorOptions();

  useEffect(() => {
    if (initialized && shouldInitializeBlock(block.id)) {
      const { type, attrs } = getInitialBlockType(block.id);
      insertBlockByType(editorRef.current, type, attrs);
      markBlockAsInitialized(block.id);
    }
  }, [initialized, block.id, shouldInitializeBlock, markBlockAsInitialized, getInitialBlockType, insertBlockByType]);

  return (
    <Draggable key={key} draggableId={draggableId} index={index}>
      {(provided: any, snapshot: any) => {
        return (
          <div
            ref={provided.innerRef}
            {...provided.draggableProps}
            className='relative group journey-text-editor__block-editor'
          >
            <DocumentCoreEditor
              editable={true}
              content={{ type: 'doc', content: block.content || '' }}
              onUpdate={(json: DocumentJSON) => {
                onUpdateBlock(json.content);
              }}
              onCreate={(editor) => {
                editorRef.current = editor;
                setInitialized(true);
              }}
            />
            <div className='absolute -left-[38px] w-[38px] top-0 h-full'>
              <div
                className={'justify-self-center cursor-grab hidden group-hover:block mt-1 ml-2'}
                {...provided.dragHandleProps}
              >
                <DragHandleSmallIcon />
              </div>
            </div>
            <div className='absolute -right-[38px] w-[38px] top-0 h-full'>
              <div
                className={classNames('justify-center hidden group-hover:block ml-2', {
                  '!block': settingsFocused,
                })}
                contentEditable='false'
              >
                <BlockSettings
                  editor={editorRef.current}
                  onDelete={onDeleteBlock}
                  onOpen={() => setSettingsFocused(true)}
                  onClose={() => setSettingsFocused(false)}
                />
              </div>
            </div>
          </div>
        );
      }}
    </Draggable>
  );
};
